import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedFormSection, {
  TransmedFormSectionInput,
} from "../../../../dtos/transmed/process/form/section";
import TransmedFormSectionApi from "../../../../api/transmed/form/section";

class TransmedProcessFormSectionReader extends ServiceReader {
  public async current(): Promise<TransmedFormSection[]> {
    return await new TransmedFormSectionApi().get();
  }
}

class TransmedProcessFormSectionServiceCreator extends ServiceCreator {
  public async section(
    title: string,
    weight: number,
    proportional: number | null
  ): Promise<TransmedFormSection> {
    return await new TransmedFormSectionApi().post(
      new TransmedFormSectionInput(title, weight, proportional)
    );
  }
}

class TransmedProcessFormSectionServiceUpdater extends ServiceUpdater {
  public async section(
    id: number,
    title: string,
    weight: number,
    proportional: number | null
  ): Promise<TransmedFormSection> {
    return await new TransmedFormSectionApi().put(
      `${id}`,
      new TransmedFormSectionInput(title, weight, proportional)
    );
  }
}

class TransmedProcessFormSectionServiceDeleter extends ServiceDeleter {
  public async section(id: number): Promise<void> {
    return await new TransmedFormSectionApi().delete(`${id}`);
  }
}

export default class TransmedProcessFormSectionService extends Service {
  public get read(): TransmedProcessFormSectionReader {
    return new TransmedProcessFormSectionReader();
  }
  public get create(): TransmedProcessFormSectionServiceCreator {
    return new TransmedProcessFormSectionServiceCreator();
  }
  public get update(): TransmedProcessFormSectionServiceUpdater {
    return new TransmedProcessFormSectionServiceUpdater();
  }
  public get delete(): TransmedProcessFormSectionServiceDeleter {
    return new TransmedProcessFormSectionServiceDeleter();
  }
}
